module.exports = __webpack_public_path__ + "static/prepaid-1fdd1b3989111134f68f70c144e7b456.svg";